module.exports = __webpack_public_path__ + "img/Logos-grandes.bb048315.png";